import React from 'react';
import { Typography, Box, Theme } from '@mui/material';
import { Image } from 'react-bootstrap';
import images from '../../../constants/images';
import { currentUserIsClient, currentUserIsManager, currentUserIsWorker } from '../../../utils/currentUser';
import { createStyles, makeStyles } from '@mui/styles';



const useStyles = makeStyles((theme: Theme) => createStyles({
    container: {
        position: "relative",
        width: "100%",
        height: "calc(100vh - 60px)",
    },
    blur: {
        "background": `blue url(${images.beFunkyPhoto})`,
        "position": "absolute",
        "width": "100%",
        "height": "100%",
        "WebkitFilter": "blur(5px)",
        "MozFilter": "blur(5px)",
        "OFilter": "blur(5px)",
        "MsFilter": "blur(5px)",
        "filter": "blur(5px)",
        "zIndex": 1
    },
    containerText: {
        width:"100%",
        position: "absolute",
        top: "50%",
        // left:"50%",
        // display:"flex",
        // justifyContent:"center",
        zIndex:999,
        padding:20
    }
}))
export type IPendingScreenProps = {

}

const PendingScreen: React.FC<IPendingScreenProps> = (props) => {
    const isManager = currentUserIsManager()
    const isWorker = currentUserIsWorker()
    const isClient = currentUserIsClient()
    const notPending = isManager || isWorker || isClient

    const classes = useStyles()

    return (
        <Box className={`${classes.container}`}>
            <Box className={`${classes.blur}`} />
            <Box className={`${classes.containerText}`}>
            <Typography style={{ color: "#F3E09B", backgroundColor: "#0A5172", padding: 20,textAlign:"center" }}>Your account is pending administrator approval.</Typography>
            </Box>
        </Box>
    );
}

export default PendingScreen
export { PendingScreen }